// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain as deleteOrder } from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/DeleteOrder";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import { getDataLayer, rcBrand } from "@rc/XDL/Utilities/DataLayer";

export interface XngDeleteOrderParameterParameter {
    cart?: CartModel;
    onSuccess?: (result: any) => void;
}

export const _GaDeleteOrder: any = (props: any) => {
    const state = props.getState();
    if (state?.xGA?.removeCartEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer || !localStorage) {
            return;
        }

        let orderingType = localStorage.getItem("orderingType");
        if (!orderingType) {
            orderingType = "Regular";
        } else if (orderingType !== "Regular") {
            orderingType = "Mixed";
        }

        localStorage.setItem("orderingType", orderingType);

        const GA4Data = {
            event: "US001eComRemoveFromCart",
            ecommerce: {
                currencyCode: state.context.session.currency?.currencyCode,
                actionField: {
                    remove: {
                        products: [],
                    },
                },
            },
        } as any;

        const cartLines = props.parameter?.cart?.cartLines;

        cartLines?.length > 0 &&
            cartLines.forEach((cartLine: any, index: number) => {
                let shortDescription = cartLine.shortDescription.replace(/<(?:.|\n)*?>/gm, "");
                shortDescription = cartLine.shortDescription.replace(/\s+/g, " ").trim();

                const lifestageValue = cartLine.properties?.lifeStage;
                const benefitsValue = cartLine.properties?.benefits;
                const category = cartLine.properties?.category;
                const variant = cartLine.properties?.variant;

                const product = {
                    id: cartLine.erpNumber,
                    price: cartLine.pricing.unitNetPrice?.toString(),
                    name: shortDescription,
                    brand: rcBrand,
                    orderingType,
                    quantity: cartLine.qtyOrdered,
                } as any;

                if (state["xGA"]["includeProductCategory"]) {
                    product["lifeStage"] = lifestageValue || "";
                    product["benefits"] = benefitsValue || "";
                    product["category"] = category || "";
                    product["variant"] = variant || "";
                }

                GA4Data.ecommerce.actionField.remove.products.push(product);
            });

        dataLayer.push(GA4Data);
    }
};

addToEndOfChain(deleteOrder, _GaDeleteOrder);
